module.exports = __webpack_public_path__ + "img/loading.65a4d1ec.gif";